import { atom } from "recoil";
import { WorkCollection } from "type/work_collection";

const defaultValue: WorkCollection[] = [];

export const workCollectionsState = atom({
  key: "workCollectionsState",
  default: defaultValue,
});
